// extracted by mini-css-extract-plugin
export var editButton = "_kt-0";